import Model from '../Model'

export default class Tag extends Model {
    // Set the resource route of the model
    resource() {
        return 'admin/dictionary/tags'
    }
}
